//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from "dayjs";
import MemberChart from "./MemberChart";
export default {
  components: { MemberChart },
  props: {
    info: {
      type: Object,
      required: true,
    },
    chartData: {
      type: Array,
      required: true,
    },
  },
  computed: {
    dateText() {
      return dayjs().format("YYYY年MM月DD日");
    },
    totalNum() {
      return this.chartData.reduce((cur, prev) => {
        return cur + prev.value;
      }, 0);
    },
  },
};
